// extracted by mini-css-extract-plugin
export default {"description":"CancelSubscriptionModal_description__-sij8","button":"CancelSubscriptionModal_button__eFljb"};